var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stats-container"},[_c('label',[_vm._v("message results")]),_c('div',{staticClass:"update-text"},[_vm._v("updates every 15 minutes, last updated "+_vm._s(_vm.statsUpdatedTime))]),_c('sb-table',{staticClass:"stats-table",attrs:{"columns":_vm.columns,"rows":_vm.rows}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }